import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';

@Component({
  selector: 'app-modal-approval',
  templateUrl: './modal-approval.component.html',
  styleUrls: ['./modal-approval.component.scss']
})
export class ModalAprovalComponent implements OnInit {
  icon: any;
  labelTitile: string;
  textDescription: any;
  textIndication: any;
  status: any;
  button = false;
  onAdd = new EventEmitter();
  onCancel = new EventEmitter();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataMessageModel) {
  }
  ngOnInit() {
    this.icon = this.data.icon;
    this.labelTitile = this.data.labelTitile;
    this.status = this.data.status;
    this.textDescription = this.data.textDescription;
    this.textIndication = this.data.textIndication;
  }

  accept() {
    this.onAdd.emit(true);
  }

  cancel() {
    this.onAdd.emit(false);
  }
}
